import { useNavigate } from "react-router-dom";

import embedInMobile from "helpers/embedInMobile";

export default function useHistory() {
  const navigate = useNavigate();

  const history = {
    push: (pathname) => {
      if (embedInMobile)
        return window.ReactNativeWebView?.postMessage(
          JSON.stringify({
            historyPush: pathname,
          }),
        );
      navigate(pathname);
    },
    replace: (pathname) => navigate(pathname, { replace: true }),
    goBack: () => navigate(-1),
  };

  return history;
}
